define(function(require,exports,module){
    var PitchLayer = require('./lib/PitchLayer');

    return PitchLayer;
});